import * as React from 'react';
import { SVGProps } from 'react';
const ScheduleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M28 12H4M11.494 12v16" />
      <path
        d="M25.333 28H6.667A2.666 2.666 0 0 1 4 25.333V6.667A2.666 2.666 0 0 1 6.667 4h18.666A2.666 2.666 0 0 1 28 6.667v18.666A2.666 2.666 0 0 1 25.333 28Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default ScheduleIcon;
